import { render, staticRenderFns } from "./admin-employees.vue?vue&type=template&id=fcff9210"
import script from "./admin-employees.vue?vue&type=script&lang=js"
export * from "./admin-employees.vue?vue&type=script&lang=js"
import style0 from "./admin-employees.vue?vue&type=style&index=0&id=fcff9210&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports